/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
`;

export const Headline = styled.h1`
    margin: 0;
    padding: 0;

    font-family: "Custora";
    font-weight: 400;
    font-size: 28px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const Subhead = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
    font-size: 16px;
    line-height: 140%;
`;

export const FullWidth = styled.div`
    width: 100%;
`;

export const PrimaryButton = styled.button`
    width: 100%;
    height: 48px;

    background: #5e84ed;
    border: none;
    border-radius: 10px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        background: #2b2d33;
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #ff8a8a;
`;

export const SuccessText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #5e84ed;
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
